// extracted by mini-css-extract-plugin
module.exports = {"container":"AdminSidebarContainer_container__bkTI2","header":"AdminSidebarContainer_header__2q5Qb","list":"AdminSidebarContainer_list__3sX56"};